module.exports = __webpack_public_path__ + "static/media/add itemss.14aef096.svg";